// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer-module--root--11CHY","logo":"Footer-module--logo--3Uan7"};